<template>
  <div class="corner-tag">
    <img v-if="tagImage" :src="tagImage" />
  </div>
</template>

<script>
export default {
  props: ['tagType'],
  data() {
    const siteUrl = window.SITE_URL;
    const lang = this.$i18n.locale === 'en' ? 'english' : 'zh-HK';
    return {
      availableTagType: [
        'gfworkshop',
        'godown',
        'mgrreco',
        'project',
        'salesreco',
        'soleagent',
        'tender',
        'video',
        'new_property',
        'covid',
      ],
      tagImageSource: `${siteUrl}img/details/tags/${lang}/`,
    };
  },
  computed: {
    tagImage() {
      if (this.availableTagType.includes(this.tagType)) {
        return `${this.tagImageSource}${this.tagType}.svg?t=20201028`;
      }
      return '';
    },
  },
};
</script>

<style scoped>
  .corner-tag {
    position: absolute;
    top: 0;
    left: 0;
    width: 16vw;
    max-width: 80px;
    height: auto;
  }

  .corner-tag img {
    width: 100%;
    height: 100%;
  }
  
  @media screen and (orientation:landscape) {
    .corner-tag img {
      max-width: 70px;
      height: auto;
    }
  }
</style>
